// LOCATION PATH ACTIONS
export const SET_LOCATION_PATH = 'SET_LOCATION_PATH';
export const SET_PREV_LOCATION_PATH = 'SET_PREV_LOCATION_PATH';
export const SET_FOCUS_ID = 'SET_FOCUS_ID';
export const SET_HG4SF_ID = 'SET_HG4SF_ID';
export const SET_APP_ERROR = 'SET_APP_ERROR';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
